import * as React from "react";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                           */
const SpecificationListItem = ({ label, value }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", { className: "product-specification-list-item__label" }, /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "text-body-head" }, label)), /* @__PURE__ */ React.createElement("dd", { className: "product-specification-list-item__value" }, /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "text-body" }, value)));
export {
  SpecificationListItem
};
//# sourceMappingURL=SpecificationListItem.js.map
